"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAllOrderList = void 0;
const react_1 = require("react");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const SimpleFuturesAPI_1 = require("../../../apis/SimpleFuturesAPI");
const interface_1 = require("../../../interface");
const utils_1 = require("../utils");
const useListenOrderStatusChange_1 = require("./useListenOrderStatusChange");
/**
 * 简易仓位列表（不限制分页；数据包括条件单和活跃订单，每次有开、关单、止赢止损修改就会刷新数据）
 * @param params SimpleFutures.ActiveOrderListUIParams
 */
const useAllOrderList = (params) => {
    const [orders, setOrders] = (0, react_1.useState)();
    const [error, setError] = (0, react_1.useState)();
    const currentParamsRef = (0, react_1.useRef)(params);
    currentParamsRef.current = params;
    const refreshRef = (0, react_1.useRef)();
    /** 清空所有状态 */
    const clear = (0, react_1.useCallback)(() => {
        setOrders(undefined);
        setError(undefined);
    }, []);
    const getDataObservable = (0, react_1.useCallback)((data) => {
        return SimpleFuturesAPI_1.SimpleFuturesAPI.getOrderList({
            page_size: 999,
            status: interface_1.SimpleFutures.OrderStatus.running,
            base: data.base,
            quote: data.quote,
        }).pipe((0, operators_1.filter)(() => {
            // 过滤掉非当前 symbol 下请求的的币对
            return data.base === currentParamsRef.current.base && data.quote === currentParamsRef.current.quote;
        }));
    }, []);
    const refresh = (0, react_1.useCallback)(() => {
        return getDataObservable(currentParamsRef.current).subscribe({
            next: (res) => {
                var _a;
                const newData = ((_a = res.results) === null || _a === void 0 ? void 0 : _a.map(utils_1.SimpleFuturesUtils.transferOrderAPIToUI)) || [];
                setOrders(newData);
            },
            error: (err) => {
                setError(err);
            },
        });
    }, [getDataObservable]);
    // 获取数据
    (0, react_1.useEffect)(() => {
        clear();
        let refresh$;
        if (params.isAppFocus && params.hasLogin) {
            refresh$ = refresh();
        }
        return () => {
            refresh$ === null || refresh$ === void 0 ? void 0 : refresh$.unsubscribe();
        };
    }, [clear, params.base, params.hasLogin, params.isAppFocus, params.quote, refresh]);
    // 监听买卖交易变化：重新获取数据
    (0, useListenOrderStatusChange_1.useListenOrderStatusChange)(params, () => {
        refreshRef.current = refresh();
    }, (wssData) => {
        var _a, _b;
        const portfolio = ((_b = (_a = wssData.bu_order_data) === null || _a === void 0 ? void 0 : _a.portfolio) === null || _b === void 0 ? void 0 : _b[0]) || {};
        const tpsl = portfolio.tp_sl_v2 || portfolio.tp_sl;
        const key = (0, trade_utils_lib_1.md5Encrypt)(`${wssData.bu_order_id}|${wssData.status}|${portfolio.position_id}|${tpsl}`);
        return key;
    });
    // 清空监听买卖交易变化带来的刷新请求
    (0, react_1.useEffect)(() => {
        return () => {
            var _a;
            (_a = refreshRef.current) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        };
    }, []);
    return {
        orders,
        error,
        refresh,
    };
};
exports.useAllOrderList = useAllOrderList;
